// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"c3a71a48","2527":"77c2aaba","8213":"66b504a4","9296":"b3fa0c66"}[chunkId] + ".chunk.css";
};